import { render, staticRenderFns } from "./QFormItem.vue?vue&type=template&id=28e2f11e&"
import script from "./QFormItem.vue?vue&type=script&lang=js&"
export * from "./QFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports